var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"options-grid__item",on:{"click":_vm.click}},[_c('span',{staticClass:"options-grid__item__label"},[_vm._t("label")],2),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }